import styled, { css } from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

// Components
import { TableComponents } from '@sketch/components'
import BaseFilter from 'components/Filter'
import { MemberCard as BaseMemberCard } from '../MemberCard'
import Banner from 'components/Banner/Banner'

export const Filter = styled(BaseFilter)`
  ${Banner} + & {
    margin-top: 20px;
  }
`

export const TableWrapper = styled.div`
  margin-top: 24px;

  ${TableComponents.Table} {
    width: 100%;

    ${/* sc-selector */ TableComponents.TableHeaderCell}:nth-child(1) {
      width: 50%;
    }

    ${/* sc-selector */ TableComponents.TableCell}:nth-last-child(1) {
      text-align: right;
      width: 40px;
    }
  }
`

export const LoadMoreWrapper = styled.div`
  margin: 24px;
  text-align: center;
`

export const MemberCard = styled(BaseMemberCard)<{ $dimmed: boolean }>`
  ${({ $dimmed }) =>
    $dimmed &&
    css`
      opacity: 0.5;
    `}
`

export const EmptyList = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.background.secondary.B};
    border-radius: ${theme.radii.large};
    margin-top: 32px;
    padding: 24px;
    text-align: center;
    color: ${theme.colors.foreground.secondary.D};
  `}
`

export const ErrorContainer = styled.div`
  margin: 48px;
`

export const StyledTableCell = styled(TableComponents.TableCell)`
  :nth-child(1) {
    max-width: 150px;
  }

  :nth-child(2) {
    ${breakpoint('base', 'sm')`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}
  }
`
